(ns ycweb.app.blitz.keepaside.keepaside
  (:require
   [ycweb.components.forms :as forms]
   [rum.core :as rum]
   [ycweb.components.flow :as flow]
   [ycweb.components.common :as cmn]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.grid :as grid]
   [ycweb.app.blitz.picking.picking :as picking]
   [ycweb.util.core :as u]
   [ycweb.util.comms :as comms]
   [ycweb.components.transitions :as t]
   [ycweb.components.wrapper :as w]))

(def steps
  (forms/setup-steps
    [{:key :choose-type :title "Get Started"}
     {:key :locations :title "Basket List"}]))

(rum/defc location-slat < rum/reactive [{:keys [lname qty]}]
  (let [colour
        (case (last lname)
          \G :green
          \R :red
          \B :blue
          \Y :yellow
          \C :grey
          :black)]
    [:article.slat-wrapper
     [:div.slat
      {:class (u/bem :picking-slat [:neutral])}
      [:div.picking-slat__graphic-wrapper
       [:span.picking-slat__icon-wrapper
        [:i {:class (u/bem :icon [:block :2-2 :location])}]]]
      [:div.picking-slat__info
       [:h3
        {:class (u/bem :picking-slat__title [:large])}
        [:span {:class (u/bem :pill [:large :picking-bin colour])}
         lname]
        [:span.picking-slat__subtext
         "Items: " [:b qty]]]]]]))

(rum/defc locations < rum/reactive [app-atom]
  (let [locations (cmn/curact app-atom [:keepaside :locations])]
    (w/wrapper app-atom "Keep Aside" {:steps steps :step :locations}
      [[:div.section
        [:div.u-margin-top-24
         [:h2.u-text-center
          {:class (u/bem :heading [:standard])}
          (str "Find Basket")
          [:span.heading__subtext
           "to take it to the store"]]]]
       [[:div.slats
         (concat
           [[:h3.heading-slat
             {:class (u/bem :slat nil)}
             [:span.heading-slat__icon-wrapper
              [:i {:class (u/bem :icon [:block :truck])}]]
             [:span.heading-slat__text
              "Find Basket to Move:"]]]
           (map location-slat locations))]]]
      []
      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-text "Find Basket"
         :right-plain true}))))

(defmethod flow/render-screen :keepaside/deliver-items [app-atom _]
  (locations app-atom))

(defmethod comms/receive :keepaside/deliver-items [app-atom {:keys [locations]}]
  (t/transition-next app-atom :keepaside/deliver-items)
  (toaster/close-toast app-atom)
  (swap! app-atom assoc-in [:keepaside :locations] locations))

(defmethod grid/action :keepaside/deliver-items [app-atom _ _]
  (toaster/open-toast app-atom :processing "Fetching items" {})
  (comms/send :keepaside/deliver-items {}))

(defmethod flow/render-screen :keepaside/picking-area [app-atom _]
  (picking/picking-area app-atom))

(defmethod comms/receive :keepaside/picking-area
  [app-atom {:keys [picking-group pickingareas defaultpickingtype pickingtypes scan-uuid]}]
  (t/transition-next app-atom :keepaside/picking-area)
  (toaster/close-toast app-atom)
  (swap! app-atom update :picking assoc
    :keepaside? true
    :scan-uuid scan-uuid
    :selected-pickingtype defaultpickingtype
    :pickingareas pickingareas
    :picking-group picking-group
    :pickingtypes pickingtypes))

(defmethod grid/action :keepaside/picking-area [app-atom _ _]
  (toaster/open-toast app-atom :processing "Fetching areas" {})
  (comms/send :keepaside/picking-area {}))

(rum/defc choose-type < rum/reactive [app-atom]
  (w/wrapper app-atom "Keep Aside" {:steps steps :step :choose-type}
    [[:div.section
      [:h2.u-text-center
       {:class (u/bem :heading [:standard])}
       "What would you like to do?"]
      [:a.card.tile.u-angled-background.u-bg-teal-blue.u-min-height-160
       {:on-click
        #(grid/dispatch-action app-atom :keepaside/picking-area {})}
       [:span.tile__content
        [:span.tile__icon-wrapper
         [:i.tile__icon
          {:class (u/bem :icon [:2-2 :stocktake :large :block])}]]
        [:span.tile__text "Pick Items"]]]
      [:a.card.or-card.tile.u-angled-background.u-bg-deep-purple.u-min-height-160
       {:on-click
        #(grid/dispatch-action app-atom :keepaside/deliver-items {})}
       [:span.tile__content
        [:span.tile__icon-wrapper
         [:i.tile__icon
          {:class (u/bem :icon [:2-2 :truck :large :block])}]]
        [:span.tile__text "Deliver Items"]]]]]
    []
    (grid/pos-call-to-action
      {:left-fn #(t/transition-next app-atom :main-menu)
       :right-plain true})))

(defmethod flow/render-screen :keepaside/choose-type [app-atom _]
  (choose-type app-atom))